import type { TAppUser, TAuthProvider } from '@core/backend'
import type { TUser } from '@core/models'

// Reached only when the SSR cookie is out of step with the stored bearer — `app.user` is otherwise
// the source of the signed-in user. Lossier than that channel: `firstName`/`lastName` have no
// backend source at all, and `plan` is absent from `/me` while SSR fills it in.
const AUTH_BY_REGISTRATION: Record<NonNullable<TUser['registrationType']>, TAuthProvider> = {
    email: 'email',
    google: 'google',
    facebook: 'facebook',
    apple: '',
    scrape: '',
    unknown: '',
}

export const toAppUser = (user: TUser): TAppUser => ({
    id: Number(user.id),
    email: user.email,
    firstName: '',
    lastName: '',
    joinDate: user.dateCreated * 1000,
    auth: user.registrationType ? AUTH_BY_REGISTRATION[user.registrationType] : '',
    username: user.username,
    avatarUrl: user.avatarUrl,
    displayName: user.profile.displayName || user.username,
    plan: '',
    browsableAudioCount: user.browsableAudioCount,
})
